import { Button, Modal, Space } from 'antd'
import { FC } from 'react'

type SaveGuardModalProps = {
  open: boolean
  isSaving: boolean
  onSaveAndContinue: () => void
  onDiscardAndContinue: () => void
  onCancel: () => void
}

export const SaveGuardModal: FC<SaveGuardModalProps> = ({
  open,
  isSaving,
  onSaveAndContinue,
  onDiscardAndContinue,
  onCancel,
}) => (
  <Modal
    title='Unsaved Changes'
    open={open}
    onCancel={onCancel}
    footer={
      <Space>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onDiscardAndContinue}>Discard & Continue</Button>
        <Button type='primary' loading={isSaving} onClick={onSaveAndContinue}>
          Save & Continue
        </Button>
      </Space>
    }>
    You have unsaved changes. Would you like to save before continuing?
  </Modal>
)
